import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()

export const navigateTo = (path) => {
  history.push(path)
}
